<template>
  <section v-if="!isRequestingUnits && !getUnits.length">
    <p class="mt-5 pt-4">
      You don't have any rental units yet.<br />Create your first one by
      clicking "Add Unit."
    </p>
    <b-button @click="onClickAddUnit"> Add Unit </b-button>
  </section>

  <section v-else>
    <pricing-scheduler />
  </section>
</template>

<script>
import { mapGetters, mapState } from "vuex";

export default {
  name: "RateManagement",

  components: {
    PricingScheduler: () => import("@/components/PricingScheduler"),
  },

  computed: {
    ...mapState({
      isRequestingUnits: (state) => state.accommodations.isRequestingUnits,
    }),

    ...mapGetters(["getUnits"]),
  },

  methods: {
    onClickAddUnit() {
      this.$router.push({
        path: "/en/settings/accommodations",
      });
    },
  },
};
</script>
